import React from 'react';
import Page from 'Components/Barcode/page';
import ReactToPrint from 'react-to-print';
import { Button, Paper } from '@mui/material';
import Loading from 'Components/MUI_components/loading';

const BarcodePreview = ({ products, setOpenBarcode, selectedDesign }) => {
  const componentRef = React.useRef();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '70vh', overflow: 'hidden' }}>
      <Paper style={{ marginTop: 10, padding: 10, overflow: 'visible', flex: 1, display: 'flex', flexDirection: 'column' }}>
        {products?.length > 0 ? (
          <>
            <div className="flex-end">
              <ReactToPrint
                trigger={() => (
                  <Button type="submit" variant="contained" color="primary">
                    Print
                  </Button>
                )}
                content={() => componentRef.current}
              />
            </div>
            <div style={{ overflowY: 'auto', flex: 1 }}>
              <div
                ref={componentRef}
                style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}
              >
                <Page
                 products={products}
                 selectedDesign={selectedDesign} />
              </div>
            </div>
          </>
        ) : (
          <Loading noIcon text="No Item selected." height={200} />
        )}
      </Paper>
    </div>
  );
};

export default BarcodePreview;
